import PersonListWithDel from './PersonListWithDel';
export default PersonListWithDel;
